import moment from 'moment'
import { ConnectionCancellationPolicies } from '@luxuryescapes/lib-refunds'
import { Refundable } from '../utils/getCancellationPolicyStatus'
import { getDateFromZonedDateString } from 'lib/datetime/dateUtils'

interface RefundPolicyDetails {
  deadline: Date | undefined
  timezone: string | undefined
  partiallyRefundableUntil: Date | undefined
  refundable: Refundable
}

export function getConnectionRefundPolicyDetails(
  cancellationPolicies: ConnectionCancellationPolicies,
  checkIn: string | undefined,
): RefundPolicyDetails {
  const hasPolicy = cancellationPolicies.policies.length > 0
  const deadline = hasPolicy ? cancellationPolicies.policies[0].deadline : undefined
  const timezone = hasPolicy ? cancellationPolicies.policies[0].timezone : undefined

  const checkInUtc = checkIn && timezone ?
      getDateFromZonedDateString(checkIn, timezone)
    : undefined

  // The policy is partially refundable until the first non-refundable deadline
  const firstNonRefundableDeadline = cancellationPolicies.policies.find(policy => policy.nonRefundable)?.deadline ?? null
  const partiallyRefundableUntil = firstNonRefundableDeadline ?? checkInUtc

  let refundable: Refundable = Refundable.Non

  // If there is at least 1 policy, and we are before every non-refundable policy's deadline (or the check-in date if there are no non-refundable policies), then the booking is partially refundable
  if (deadline && partiallyRefundableUntil && moment().utc().isBefore(partiallyRefundableUntil)) {
    refundable = Refundable.Partial
  }

  // If there is at least 1 policy, and we are before every policy's deadline, then the booking is fully refundable
  if (deadline && moment.utc().isBefore(deadline)) {
    refundable = Refundable.Fully
  }

  return {
    deadline,
    timezone,
    partiallyRefundableUntil,
    refundable,
  }
}
